import { GlAvatarLabeled, GlIcon } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import ListActions from '../list_actions/list_actions.vue?vue3';
import TimeAgoTooltip from '../time_ago_tooltip.vue?vue3';
import { TIMESTAMP_TYPES, TIMESTAMP_TYPE_CREATED_AT, TIMESTAMP_TYPE_UPDATED_AT, TIMESTAMP_TYPE_LAST_ACTIVITY_AT } from '~/vue_shared/components/resource_lists/constants';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import ListItemDescription from './list_item_description.vue?vue3';
export default {
    name: 'ListItem',
    i18n: {
        [TIMESTAMP_TYPE_CREATED_AT]: __('Created'),
        [TIMESTAMP_TYPE_UPDATED_AT]: __('Updated'),
        [TIMESTAMP_TYPE_LAST_ACTIVITY_AT]: __('Updated')
    },
    components: {
        GlAvatarLabeled,
        GlIcon,
        ListActions,
        TimeAgoTooltip,
        ListItemDescription
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        resource: {
            type: Object,
            required: true,
            validator (resource) {
                const requiredKeys = [
                    'id',
                    'avatarUrl',
                    'avatarLabel',
                    'relativeWebUrl'
                ];
                return requiredKeys.every((key)=>Object.prototype.hasOwnProperty.call(resource, key));
            }
        },
        showIcon: {
            type: Boolean,
            required: false,
            default: false
        },
        iconName: {
            type: String,
            required: false,
            default: null
        },
        actions: {
            type: Object,
            required: false,
            default () {
                return {};
            }
        },
        timestampType: {
            type: String,
            required: false,
            default: TIMESTAMP_TYPE_CREATED_AT,
            validator (value) {
                return TIMESTAMP_TYPES.includes(value);
            }
        },
        listItemClass: {
            type: [
                String,
                Array,
                Object
            ],
            required: false,
            default: ''
        },
        contentTestid: {
            type: String,
            required: false,
            default: null
        },
        avatarAttrs: {
            type: Object,
            required: false,
            default () {
                return {};
            }
        },
        descriptionAttrs: {
            type: Object,
            required: false,
            default () {
                return {};
            }
        }
    },
    emits: [
        'click-avatar'
    ],
    computed: {
        avatarLabelLink () {
            return this.resource.avatarLabelLink || this.resource.relativeWebUrl;
        },
        statsPadding () {
            return this.showIcon ? 'gl-pl-11' : 'gl-pl-8';
        },
        timestamp () {
            return this.resource[this.timestampType];
        },
        timestampText () {
            return this.$options.i18n[this.timestampType];
        },
        hasActions () {
            return this.glSlots().actions || Object.keys(this.actions).length && this.resource.availableActions?.length;
        }
    }
};
